import { Skeleton } from "antd";
import React from "react";
import { SkeletonType } from "Explore/Config/ImageType";
import styles from "./Loading.module.scss";

const LoadingSimpleComponent = ({
  component,
  type,
  rows = 2,
  className,
  isLoading,
}) => {
  if (type == SkeletonType.IMAGE) {
    return (
      <div className={className}>
        {isLoading ? <Skeleton.Avatar active shape="circle" /> : component}
      </div>
    );
  } else if (type == SkeletonType.INPUT) {
    return (
      <div className={className}>
        {isLoading ? <Skeleton.Input active /> : component}
      </div>
    );
  } else if (type == SkeletonType.PARAGRAPH) {
    return (
      <div style={{ width: "100%" }} className={className}>
        {isLoading ? (
          <div
            style={{ width: "100%", display: "flex", justifyContent: "center" }}
          >
            <Skeleton
              active
              paragraph={{
                rows,
              }}
            />
          </div>
        ) : (
          component
        )}
      </div>
    );
  } else if (type === SkeletonType.COVER_IMAGE) {
    return (
      <div className={className}>
        {isLoading ? (
          <Skeleton.Image active className={styles["full-cover"]} />
        ) : (
          component
        )}
      </div>
    );
  }
};

export default LoadingSimpleComponent;
